import Calendar from "./partials/Calendar";
import * as Styled from "./styles";
import { useCalendar } from "./hooks";

const Dashboard = () => {
  const calendar = useCalendar();

  return (
    <Styled.CalendarWrapper>
      <Calendar {...calendar} />
    </Styled.CalendarWrapper>
  );
};

export default Dashboard;
